import { Navigate, useParams } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import ProfileCompletionStep from './onboarding/ProfileCompletionStep'
import TenancyOnboardingStep from './onboarding/TenancyOnboardingStep'

export default function ProtectedRoute({ children, redirectToSlug = false }) {
  const { isAuthenticated, loading, needsProfileCompletion, needsOnboarding, getActiveSlug, user } = useAuth()
  const { slug } = useParams()

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // Check onboarding status
  if (needsProfileCompletion()) {
    return (
      <>
        {children}
        <ProfileCompletionStep />
      </>
    )
  }

  if (needsOnboarding()) {
    return (
      <>
        {children}
        <TenancyOnboardingStep />
      </>
    )
  }

  const activeSlug = getActiveSlug()

  // If this is a redirect-only route (root or catch-all), redirect to the active tenancy slug
  if (redirectToSlug) {
    if (activeSlug) {
      return <Navigate to={`/${activeSlug}`} replace />
    }
    // No active tenancy - this shouldn't happen after onboarding, but handle it
    return <Navigate to="/login" replace />
  }

  // Validate that the URL slug matches one of the user's tenancies
  const matchingTenancy = user?.tenancies?.find(t => t.slug === slug)
  if (!matchingTenancy) {
    // Slug doesn't match any of the user's tenancies - redirect to active tenancy
    if (activeSlug) {
      return <Navigate to={`/${activeSlug}`} replace />
    }
    return <Navigate to="/login" replace />
  }

  return children
}
